import { ResourceFragment } from "@/generated/graphql";
import { ResourceList } from "@/ui/task/resources";
import {
  useAddResource,
  useDeleteResource,
  useMoveResource,
  useUpdateResource,
  useUploadResource,
} from "@/ui/task/resources/hooks";

interface ResourcesProps {
  assessmentId: string;
  taskId: string;
  resources: ResourceFragment[];
}

export function Resources(props: ResourcesProps) {
  const { resources, assessmentId, taskId } = props;

  const [moveResource] = useMoveResource(assessmentId, taskId);
  const [addResource, adding] = useAddResource(assessmentId, taskId);
  const [updateResource] = useUpdateResource(resources);
  const [uploadResource, uploading] = useUploadResource(assessmentId, taskId);
  const [deleteResource] = useDeleteResource();

  return (
    <ResourceList
      resources={resources}
      moveResource={moveResource}
      onUpdateResource={updateResource}
      onAdd={addResource}
      onUpload={uploadResource}
      onDelete={deleteResource}
      isLinking={adding || uploading}
    />
  );
}
